// Generated types for Concern
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { RequirementReadAPI, RequirementWriteAPI } from './requirement';
import { RequirementReadAPISchemaObject, RequirementWriteAPISchemaObject } from './requirement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ConcernReadAPI extends RequirementReadAPI {
}

export interface ConcernWriteAPI extends Omit<RequirementWriteAPI, 'conflicts_with' | 'container' | 'derives_from' | 'frames_concerns' | 'refines' | 'sources' | 'sub_requirements' | 'transformed_from'> {
  container?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ConcernReadAPISchema: z.ZodType<ConcernReadAPI> = RequirementReadAPISchemaObject.extend({}).passthrough();

export const ConcernWriteAPISchema: z.ZodType<ConcernWriteAPI> = RequirementWriteAPISchemaObject.omit({ 'conflicts_with': true, 'container': true, 'derives_from': true, 'frames_concerns': true, 'refines': true, 'sources': true, 'sub_requirements': true, 'transformed_from': true }).extend({
  container: z.string().optional(),
}).passthrough();
